import { getText } from './language';
import config from './renewal.json';

export const declineReason = (family) => getText('renewal_decline_' + (config.declineFamilies.includes(family) ? family : 'other'));
